
import { IPaymentConfig, IPaymentConfigResponse } from '../../interfaces/IPaymentConfig'
import * as paymentAPIUtils from '../../util/payment/paymentAPIUtil'

export const RECEIVE_CONFIG = '[Payment] RECEIVE_CONFIG'
export const FETCH_ERROR = '[Payment] FETCH_ERROR'
export const IS_LOADING = '[Payment] IS_LOADING'

export const receivePaymentConfig = (config: IPaymentConfig) => ({
  type: RECEIVE_CONFIG,
  payload: config,
})

export const sendFetchError = () => ({
  type: FETCH_ERROR,
})

export const isLoading = val => ({
  type: IS_LOADING,
  payload: val,
})

export const fetchPaymentConfig = () => dispatch => paymentAPIUtils.getPaymentGateway()
  .then(res => {
    const paymentConfigResponse: IPaymentConfigResponse = res.data
    if (paymentConfigResponse.data.length > 0) {
      dispatch(receivePaymentConfig(paymentConfigResponse.data[0]))
    }
  }).catch(error => {
    console.log('orders list error', error)
    dispatch(isLoading(false))
    dispatch(sendFetchError())
  })
